/*
    default prefix "CLICK_MANAGER"
*/

export const AT_SELECTED_CARD_IDS_SET = 'CLICK_MANAGER_SELECTED_CARD_IDS_SET';
export const AT_SELECTED_LIST_IDS_SET = 'CLICK_MANAGER_SELECTED_LIST_IDS_SET';
export const AT_CLICK_MANAGER_MODEL_INITIAL_STATE_SET = 'CLICK_MANAGER_CLICK_MANAGER_MODE_INITIAL_STATE_SET';
